var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4502 6.24438L3.91797 13.9631C3.85589 14.0339 3.76545 14.0696 3.67578 14.0696H1.5791C1.38604 14.0695 1.23438 13.9131 1.23438 13.7151V11.5647C1.23439 11.4657 1.26893 11.3805 1.33789 11.3098L8.86328 3.59204L11.4502 6.24438ZM11.3496 1.33325C11.532 1.33327 11.7071 1.40783 11.8359 1.54028L13.4502 3.19556C13.7191 3.47147 13.7192 3.91774 13.4502 4.1936L12.1875 5.48755L9.60059 2.83521L10.8633 1.54028C10.9922 1.40781 11.1672 1.33325 11.3496 1.33325Z",
    fill: "#6A6DA6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 13.0908,
    width: 8.75895,
    height: 0.875895,
    rx: 0.437947,
    fill: "#6A6DA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPreviewIcon);
export default __webpack_public_path__ + "static/media/edit-preview-icon.d1d66bbd.svg";
export { ForwardRef as ReactComponent };